const makeSearchFilters = pharmacy => ({
  devicesOnly: pharmacy === 'wardles',
});

export default makeSearchFilters;
